/**
 * 扫码跳转到对应信息
 */
 import axios from '../request';
 export default{
    // 查询生产信息信息
    searchBearInfo: params =>
        axios.post('/m/pipeInfo/h5PipeList', params),
    // 查询质量追溯（管片，钢筋笼，模具）
    searchMassInfo: params =>
        axios.post('/m/pipeInfo/checkHistory', params),
    // 查询养护信息
    searchCuringInfo: params =>
        axios.post('/m/waterCultivated/getH5WaterRecord', params),
    //查询模具单独页面
    searchModelInfo: params =>
        axios.get('/m/modcheck/getH5MouldInfo', {params}),
    //查询钢筋笼单独页面
    searchReinInfo: params =>
        axios.get('/m/steelProduce/getH5SteelProduce', {params}),
    //查询连锁块打包页面
    searchChainInfo: params =>
        axios.get('/materials/chainPack/packH5Info', {params}),
 }